import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Nautilus Shell — golden-ratio spiral shell structure.
 * spiral3D as primary shape, bubble3D for rounded chambers,
 * and disc3D for petal-like ridges.
 */
export const example40 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Nautilus Shell',
    description:
      'golden-ratio spiral shell structure. spiral3D as primary shape, bubble3D for rounded chambers, and disc3D for petal-like ridges.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -2.9,
    skipIters: 20,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.0,
    contrast: 4.0,
    gamma: 3.2,
    depthColorPower: 0.0,
    lightDirection: [-0.6, 0.4, -0.7],
    lightPower: 0.1,
    highlightPower: 1.0,
    densityEstimationQuality: 0.7,
    estimatorCurve: 0.4,
    paletteMode: 0,
    palettePhase: 0.08,
    paletteSpeed: 0.45,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 2.5,
      phi: 1.5,
      radius: 1.7,
      target: [0, 0, 0],
      fov: 55,
    },
  },
  transforms: {
    [tid('3d_nautilus_a')]: {
      probability: 0.45,
      preAffine: {
        a: 0.85,
        b: 0.1,
        c: 0,
        d: 0,
        e: -0.1,
        f: 0.85,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.85,
        l: 0.05,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.15, y: 0.35 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_nautilus_a_v0')]: { type: 'spiral3D', weight: 0.9 },
        [vid('3d_nautilus_a_v1')]: { type: 'linear3D', weight: 0.2 },
      },
    },
    [tid('3d_nautilus_b')]: {
      probability: 0.3,
      preAffine: {
        a: 0.65,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.65,
        g: 0,
        h: 0.1,
        i: 0,
        j: 0,
        k: 0.65,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.15, y: 0.15 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_nautilus_b_v0')]: { type: 'bubble3D', weight: 0.7 },
        [vid('3d_nautilus_b_v1')]: { type: 'disc3D', weight: 0.4 },
      },
    },
    [tid('3d_nautilus_c')]: {
      probability: 0.25,
      preAffine: {
        a: 0.5,
        b: 0,
        c: 0,
        d: 0.15,
        e: 0,
        f: 0.5,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0.15,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.4, y: -0.1 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_nautilus_c_v0')]: { type: 'spiral3D', weight: 0.6 },
        [vid('3d_nautilus_c_v1')]: { type: 'spherical3D', weight: 0.3 },
      },
    },
  },
})
